import React, { useState, useRef } from 'react'
import Layout from '../../Layout'
import { TableStyle } from './style'
import Header from '../../Header'
import CustomTable from '../../CustomTable'
import useAxios from 'axios-hooks'
import { Card, Space, Typography, Row, Col, Modal, Select, Button, Input, message } from 'antd'
import { StatusBar } from '../../Invoice/InvoiceSummary/style'
import ReceiptStatus from '../ReceiptStatus'
import { EditStyle } from '../../Invoice/InvoiceSummaryTab/style'
import { EditOutlined, CheckOutlined, MailOutlined, SendOutlined, FileOutlined, PlusOutlined } from '@ant-design/icons'
import { format } from 'date-fns'
import currency from "currency.js";

const ReceiptDetails = ({ receipt_summary, invoice_group, lender, partner, partially_paid, email: currentEmail }) => {
  const email = useRef()
  const receipt_summary_id = receipt_summary.id
  const { Title, Text, Paragraph } = Typography
  const [currentPage, setCurrentPage] = useState(1)
  const [search, setSearch] = useState('')
  const [noteView, setNoteView] = useState(receipt_summary.note)
  const [noteLenderView, setNoteLenderView] = useState(receipt_summary.lender_note)
  const [isModalReportOpen, setIsModalReportOpen] = useState(false)
  const [typeReport, setTypeReport] = useState('noburo')
  const [isModalEmailOpen, setIsModalEmailOpen] = useState(false)

  const statusView = receipt_summary.status
  const lenderReceived = receipt_summary.lender_received
  const noburoReceived = receipt_summary.noburo_received


  const columns = [
    { title: 'เลขที่เอกสาร', dataIndex: 'receipt_no', key: 'receipt_no', render: (text) => <a>{text}</a> },
    { title: 'เลขบัตรประชาชน', dataIndex: 'citizen_id', key: 'citizen_id', render: (text) => <a>{text}</a> },
    { title: 'ชื่อ', dataIndex: 'firstname', key: 'firstname', render: (text) => <a>{text}</a> },
    { title: 'นามสกุล', dataIndex: 'lastname', key: 'lastname', render: (text) => <a>{text}</a> },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text) => <a>{format(new Date(text), 'yyyy-MM-dd')}</a>,
    },
    { title: 'ค่าแอปพลิเคชัน', dataIndex: 'application_fee', key: 'application_fee', render: (text) => <a>{text}</a> },
    { title: 'ค่าธรรมเนียมเบิกถอน', dataIndex: 'withdrawal_fee', key: 'withdrawal_fee', render: (text) => <a>{text}</a> },
    { title: 'ภาษีมูลค่าเพิ่ม 7%', dataIndex: 'total_vat', key: 'total_vat', render: (text) => <a>{text}</a> },
    { title: 'รวม', dataIndex: 'total', key: 'total', render: (text) => <a>{text}</a> },
  ]

  const [{ loading: loadingUpdateSummary }, updateSummary] = useAxios({
    url: `/admins/api/receipt_summaries/update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }, { manual: true })

  const [{ data, loading }, refetch] = useAxios({
    url: `/admins/api/receipt_summaries/${receipt_summary_id}/receipt_details?page=${currentPage}&search=${search}`,
    method: 'GET',
    headers: {
      'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': '0',
    },
  }, { useCache: false })

  const [{ loading: loadingSendEmail }, sendEmail] = useAxios({
    url: `/admins/api/receipt_summaries/send_email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  }, { manual: true })

  const [{ loading: loadingCreateXlsx }, createXlsx] = useAxios({
    url: `/admins/api/receipt_summaries/create_xlsx`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  }, { manual: true })

  const handleCreateXlsx = async () => {
    try {
      await createXlsx({
        data: JSON.stringify({
          type: typeReport,
          receipt_summary_id
        })
      })
      message.success({
        content: 'สร้างรายงานสำเร็จ คลิ๊กที่เพื่ือตรวจสอบไฟล์ และ ดาวน์โหลด',
        duration: 5,
        onClick: () => window.open(`/admins/requested_files`)
      })
      await refetch()
    } catch (e) {
      console.log(e)
    }
    setIsModalReportOpen(false)
  }

  const handleSendEmail = async () => {
    try {
      await sendEmail({
        data: JSON.stringify({
          email: email.current.input.value,
          ids: [receipt_summary_id]
        })
      })
      setIsModalEmailOpen(false)
    } catch (e) {
      // Optionally handle error
    }
  }

  const optionSelectReport = [
    { id: 1, value: 'noburo', label: 'noburo' },
    { id: 2, value: 'lender', label: 'Lender' }
  ]

  return (
    <Layout>
      <StatusBar>
        <ReceiptStatus
          status={statusView === 'paid' ? (partially_paid ? 'partially_paid' : statusView) : statusView}
          size="large"
        />
      </StatusBar>
      <Header title={`ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ : ${receipt_summary.tax_id}`}>
        <Space size="small">
          <Button type="primary" size="large" onClick={() => setIsModalEmailOpen(true)} icon={<SendOutlined />}>
            ส่งอีเมล
          </Button>
          <Button type="primary" size="large" onClick={() => setIsModalReportOpen(true)} icon={<PlusOutlined />}>
            สร้างรายงาน
          </Button>
          <Button type="primary" size="large" icon={<FileOutlined />}
            onClick={() => window.open(`${receipt_summary_id}/preview`)}>
            ตัวอย่าง
          </Button>
        </Space>
      </Header>

      {invoice_group && (
        <a target="_blank" rel="noreferrer" href={`/admins/invoice/invoice_summary/${invoice_group.id}`} key={invoice_group.id}>
          {invoice_group.no}
        </a>
      )}

      <Card
        title={`${lender.name} (${lender.lms_project_id})`}
        extra={<a href={`/admins/lenders/${lender.id}/edit`}>แก้ไข</a>}
        headStyle={{
          fontFamily: 'SukhumvitSet-Bold',
          background: '#efefef'
        }}
      >
        <Row gutter={16}>
          <Col className="gutter-row" span={12}>
            <Card
              title="ชื่อลูกค้า"
              extra={<a href={`/admins/partners/${partner.id}/edit`}>แก้ไข</a>}
              style={{ flex: 1 }}
            >
              <Space direction="vertical" size={0}>
                <Title style={{ fontFamily: 'SukhumvitSet-Bold' }} level={5}>{partner.name}</Title>
                <Text>
                  {partner.tax_id ? partner.tax_id : 'ไม่พบเลขผู้่เสียภาษี'} ({partner.branch ? partner.branch : 'สำนักงานใหญ่'})
                </Text>
                <Text>ที่อยู่ : {partner.address}</Text>
                <Text>{partner.subdistrict} {partner.district} {partner.province} {partner.post_code}</Text>
              </Space>
            </Card>
          </Col>
          <Col className="gutter-row" span={12} style={{ display: 'flex' }}>
            <Card title="ข้อมูลเอกสาร" style={{ flex: 1 }}>
              <Space>
                <Text>
                  Note for Lender :
                  <EditStyle style={{ width: 200 }}>
                    <Paragraph
                      editable={{
                        icon: <EditOutlined />,
                        enterIcon: <CheckOutlined />,
                        tooltip: 'Click To Edit Widget Name',
                        onChange: async (val) => {
                          setNoteLenderView(val)
                          await updateSummary({
                            data: JSON.stringify({
                              receipt_summary_ids: [receipt_summary_id],
                              lender_note: val
                            })
                          })
                        }
                      }}
                    >
                      {noteLenderView ? noteLenderView : 'ไม่มี'}
                    </Paragraph>
                  </EditStyle>
                </Text>
                <Text>
                  Note for noburo :
                  <EditStyle style={{ width: 200 }}>
                    <Paragraph
                      editable={{
                        icon: <EditOutlined />,
                        enterIcon: <CheckOutlined />,
                        tooltip: 'Click To Edit',
                        onChange: async (val) => {
                          setNoteView(val)
                          await updateSummary({
                            data: JSON.stringify({
                              receipt_summary_ids: [receipt_summary_id],
                              note: val
                            })
                          })
                        }
                      }}
                    >
                      {noteView ? noteView : 'ไม่มี'}
                    </Paragraph>
                  </EditStyle>
                </Text>
              </Space>
              <Space style={{ marginBottom: 16 }}>
                <Text>
                  วันที่สถาบันการเงินได้รับเงิน :
                  <br />
                  <EditStyle style={{ width: 200 }}>
                    {receipt_summary.transfer_date ? format(new Date(receipt_summary.transfer_date), 'yyyy-MM-dd') : 'ไม่มี'}
                  </EditStyle>
                </Text>
                <Text>
                  เข้าบัญชีสถาบันการเงิน (บาท) :
                  <br />
                  <EditStyle style={{ width: 200 }}>
                    {lenderReceived ? currency(lenderReceived).format({ symbol: '', separator: ',', precision: 2 }) : 'ไม่มี'}
                  </EditStyle>
                </Text>
              </Space>
              <Space>
                <Text>
                  วันที่ noburo ได้รับเงิน :
                  <br />
                  <EditStyle style={{ width: 200 }}>
                    {receipt_summary.transfer_date_noburo ? format(new Date(receipt_summary.transfer_date_noburo), 'yyyy-MM-dd') : 'ไม่มี'}
                  </EditStyle>
                </Text>
                <Text>
                  เข้าบัญชี noburo (บาท) :
                  <br />
                  <EditStyle style={{ width: 200 }}>
                    {noburoReceived ? currency(noburoReceived).format({ symbol: '', separator: ',', precision: 2 }) : 'ไม่มี'}
                  </EditStyle>
                </Text>
              </Space>
            </Card>
          </Col>
        </Row>
      </Card>
      <TableStyle>
        <CustomTable
          loading={loading}
          columns={columns}
          data={data ? data.receipt_details : []}
          total={data ? data.total_pages : 0}
          currentPage={currentPage}
          searchPlaceholder="ค้นหาโดย เลขที่เอกสาร เลขบัตรประชาชน ชื่อ นามสกุล"
          setCurrentPage={setCurrentPage}
          setSearch={setSearch}
        />
      </TableStyle>

      <Modal title="ส่งอีเมล" open={isModalEmailOpen} footer={null} onCancel={() => setIsModalEmailOpen(false)}>
        <Input size="large" ref={email} defaultValue={currentEmail} placeholder="กรอกอีเมล" prefix={<MailOutlined />} />
        <Button
          size="large"
          style={{ marginTop: '10px' }}
          type="primary"
          loading={loadingSendEmail}
          onClick={handleSendEmail}
        >
          ส่งอีเมล
        </Button>
      </Modal>

      <Modal title="สร้างรายงาน" open={isModalReportOpen} footer={null} onCancel={() => setIsModalReportOpen(false)}>
        <div>ประเภทรายงาน:</div>
        <Select
          style={{ width: 280, marginBottom: '10px', marginTop: '10px' }}
          defaultValue={optionSelectReport[0]}
          size="large"
          placeholder="ประเภทรายงาน"
          onChange={setTypeReport}
          options={optionSelectReport}
        />
        <Button
          size="large"
          style={{ marginTop: '10px' }}
          type="primary"
          loading={loadingCreateXlsx}
          onClick={handleCreateXlsx}
        >
          ตกลง
        </Button>
      </Modal>
    </Layout>
  )
}

export default ReceiptDetails
